import Rest from '../rest'

/******************************************************************************
 *  Integrations
 *****************************************************************************/

/**
 * @type {Integration}
 */
export default class Integration extends Rest {

    constructor () {
        super('/integrations')
    }

    /**
    * Ativa ou desativa o modo de depuração para o envio de proposta
    * @param {boolean} enable - Se true, ativa o modo de depuraçãopara o envio de proposta, caso contrário desativa.
    */
    updateProposalDebugger(enable) {
        return this.updateV2(`erp/configurations/debug-mode-proposal?enable=${enable ? 1 : 0}`, '')
    }
}